
const VERSION = {
  SHA1:'0ac63e8d3dc67fa3337b86a07b1980e99f9f272b',
  VERSION:2291,
  BRANCH:'main',
  PROJECT:'ostium-ne'
}
export default VERSION;
